<template>
  <div class="status-row">
    <el-tag
      v-if="status == $options.statuses.READY"
      effect="dark"
      class="status-tag"
      title="Conversion Ready"
      type="success"
    >
      Ready
    </el-tag>

    <el-tag
      v-else-if="status == $options.statuses.REMOTE"
      effect="dark"
      class="status-tag"
      title="Conversion remote"
      type="success"
    >
      Remote
    </el-tag>

    <el-tag
      v-else-if="status == $options.statuses.ENQUEUED"
      effect="dark"
      size="mini"
      class="status-tag enqueued"
      title="This Item is in conversion queue"
      type="primary"
    >
      Enqueued
    </el-tag>

    <el-tag
      v-else-if="status == $options.statuses.CONVERTING"
      effect="dark"
      class="status-tag"
      title="Conversion in progress"
      loading
      type="info"
    >
      <span>Converting</span>
    </el-tag>

    <el-tag
      v-else-if="status == $options.statuses.POSTPROCESSING"
      effect="dark"
      class="status-tag"
      title="Media postprocessing"
      loading
      type="info"
    >
      <span>Postprocessing</span>
    </el-tag>

    <el-tag
      v-else
      effect="dark"
      class="status-tag"
      title="Conversion Failed"
      type="warning"
    >
      <span>Failed</span>
    </el-tag>
  </div>
</template>

<script>
import { MEDIA_CONVERSION_STATUS, isMediaStatusValid } from "@/constants.js";

// @group Media/Video
// Video conversion status
export default {
  name: "VideoHeaderStatus",
  props: {
    /** Conversion status */
    status: {
      type: String,
      default: MEDIA_CONVERSION_STATUS.READY,
      validator(val) {
        return isMediaStatusValid(val);
      }
    },
    /** Conversion percentage */
    progress: {
      type: Number,
      default: 0,
      validator(val) {
        return 0 <= val && val <= 100;
      }
    }
  },
  statuses: MEDIA_CONVERSION_STATUS
};
</script>

<style scoped>
.status-row {
  display: flex;
  justify-content: flex-end;
  margin: 0 10px;
}

/** tag */
.el-tag.el-tag--info {
  color: white !important;
  border: none;
}
.el-tag {
  color: white;
  display: flex;
  align-items: center;

  height: 2rem !important;
  padding: 0 10px;
}
.status-tag {
  cursor: help;
  color: white;
}
.status-tag.enqueued {
  color: var(--grey);
}

@media only screen and (max-width: 440px) {
  .status-row {
    margin: 0 3px;
  }
  .el-tag {
    height: 1.6rem !important;
    font-size: 12px;
  }
}
@media only screen and (min-width: 768px) {
  .el-tag {
    height: 2rem !important;
    font-size: 14px;
  }
}
@media only screen and (min-width: 992px) {
  /** status tag */
  .el-tag {
    height: 1.8rem !important;
    font-size: 10px !important;
  }
}
@media only screen and (min-width: 1200px) {
  .el-tag {
    height: 2rem !important;
    font-size: 12px !important;
  }
}
@media only screen and (min-width: 1920px) {
  /** status tag */
  .el-tag {
    font-size: 14px !important;
  }
}
</style>
